import {Service, service, inject} from "./di";
import { FlyerService } from "./FlyerService";
import { LocationService } from "./LocationService";
import { Flyer } from "../definitions/FlyerDefinitions";
import { SeoService } from "./SeoService";
import { LinkService } from "./LinkService";
import MetadataService from "./MetadataService";

@service
export class ExpiredCanonicalsService extends Service {
	@inject flyerService: FlyerService;
	@inject location: LocationService;
	@inject seoService: SeoService;
	@inject linkService: LinkService;
	@inject metadataService: MetadataService;

	async getFlyersLink(): Promise<string> {
		const merchantNames = this.getMerchantNamesFromUrl();
		const flyers = await this.findMerchant(merchantNames);
		const locale = this.metadataService.getLocale();
		if (flyers.length === 0) {
			return `/${locale}/${this.location.getInCity()}/flyers`;
		}

		this.seoService.setLocale(this.metadataService.getLocale());
		const flyer = flyers.pop();
		return this.linkService.linkTo(flyer);
	}

	async getCouponsLink(): Promise<string> {
		return `/${this.metadataService.getLocale()}/${this.location.getInCity()}/coupons`;
	}

	async getItemLink(): Promise<string> {
		return `/${this.metadataService.getLocale()}/${this.location.getInCity()}`;
	}

	async findMerchant(merchantNames: string[]): Promise<Flyer[]> {
		while (merchantNames.length > 0) {
			const merchantName = merchantNames.pop();
			const flyers = await this.flyerService.getFlyersByMerchantName(merchantName, false);
			if (flyers.length > 0) {
				return flyers;
			}
		}

		return [];
	}

	getMerchantNamesFromUrl() {
		const names = [];
		const flyerIdAndName = window.location.pathname.split("/").pop();
		const flyerIdAndNameSplitted = flyerIdAndName.split("-");
		flyerIdAndNameSplitted.shift();

		while (flyerIdAndNameSplitted.length > 0) {
			const name = flyerIdAndNameSplitted.reduce((result, value) =>
				result.length === 0 ? `${value}` : `${result}-${value}`
				, ""
			);
			names.push(name);
			flyerIdAndNameSplitted.pop();
		}

		return names;
	}

}

